import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAVPCpknjmU_EVhCFCELe__kw-nMqbgseo",
  authDomain: "onenetwork-f8a40.firebaseapp.com",
  projectId: "onenetwork-f8a40",
  storageBucket: "onenetwork-f8a40.firebasestorage.app",
  messagingSenderId: "784410006270",
  appId: "1:784410006270:web:475c05acc2b0111d834baf",
  measurementId: "G-1Q0ZY6TQPF"
};
const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

export { messaging, getToken, onMessage }
